var moment = require('moment');

function displayError(el, type) {
    $(el).closest(".form-group").addClass('error-input');
    
    switch(type) {
        case 'email1':
            $('.email1').removeClass('d-none');
            break;
        case 'email2':
            $('.email2').removeClass('d-none');
            break;
        case 'date1':
            $('.date1').removeClass('d-none');
            break;
        case 'date2':
            $('.date2').removeClass('d-none');
            break;
        default:
            break;
    }
}

function displaySuccess(el) {
	$(el).closest(".form-group").removeClass('error-input');
}

function isEmpty(el) {
    if ($(el).val() === '' || $(el).val() === null) {
        return true;
    } else {
        return false;
    }
}

function isValidUSZip(sZip) {
    return /^\d{5}(-\d{4})?$/.test(sZip);
}

function isValidEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function isValidMMDDYYYYDate(dob) {
    let re = /^(((0?[1-9]|1[012])\/(0?[1-9]|1\d|2[0-8])|(0?[13456789]|1[012])\/(29|30)|(0?[13578]|1[02])\/31)\/(19|[2-9]\d)\d{2}|0?2\/29\/((19|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([2468][048]|[3579][26])00)))$/;

    return re.test(dob);
}

function isValidPhone(phone) {
    const re = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
    return re.test(String(phone));
}

const textValidate = (el) => {
    if (isEmpty(el)) {
        displayError(el, 'empty');
        return 0;
    } else {
        displaySuccess(el);
    }
    return 1;
};

const zipValidate = (el) => {
    if (isEmpty(el) || !isValidUSZip($(el).val())) {
        displayError(el, 'zipcode');
        return 0;
    } else {
        displaySuccess(el);
    }
    return 1;
};

const emailValidate = (el) => {
    $(".email-error").addClass('d-none');

    if (isEmpty(el)) {
        displayError(el, 'email1');
        return 0;
    } else if(!isValidEmail($(el).val())) {
        displayError(el, 'email2');
        return 0;
    } else if ($(el).val().indexOf('+') > -1) {
        displayError(el, 'emailplus');
        return 0;
    } else {
        displaySuccess(el);
    }
    return 1;
};

const dobValidate = (el) => {
    $(".dob-error").addClass('d-none');

    if(isEmpty(el)) {
        displayError(el, 'date1');
        return 0;
    } else if(!isValidMMDDYYYYDate($(el).val())) {
        displayError(el, 'date2');
        return 0;
    } else {
        displaySuccess(el);
    }
    
    return 1;
};

const ageValidate = (el) => {
    let now = moment();
    let userDate = moment(el)
    let age = moment.duration(now.diff(userDate));

    return age.years();
};

const validateEmployment = (el) => {
    switch(el) {
        case 'Yes':
            return "1";
        case "No":
        default:
            return "";
    }
}

const validateHealth = (el) => {
    switch(el) {
        case "poor":
            return "1";
        case "fair":
            return "2";
        case "good":
            return "3";
        case "great":
            return "4";
        default:
            return "";
    }
}

const phoneValidate = (el) => {
    if (isEmpty(el) || !isValidPhone($(el).val())) {
        displayError(el, 'phone');
        return 0;
    } else {
        displaySuccess(el);
    }
    return 1;
};

const selectValidate = (el) => {
    if (isEmpty(el)) {
        displayError(el, 'empty');
        return 0;
    } else {
        displaySuccess(el);
    }
    return 1;
};

const checkboxValidate = (el) => {
    let name = $(el).attr('name');
    let checked = $(`input[name='${name}']:checked`);
    if (checked.length === 0) {
        let parent = $(el).closest('.checkbox-list');
        displayError(parent, 'empty');
        return 0;
    }
    return 1;
};


const radioValidate = (el) => {
    let name = $(el).attr('name');
    let checked = $(`input[name='${name}']:checked`);
    if (checked.length === 0) {
        displayError(el, 'empty');
        return 0;
    } else {
        displaySuccess(el);
    }
    return 1;
};

export default { 
    textValidate,
    zipValidate,
    emailValidate,
    phoneValidate,
    selectValidate,
    checkboxValidate,
    radioValidate,
    dobValidate,
    ageValidate,
    validateEmployment,
    validateHealth,
    isValidUSZip
};